import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";

import {
  AutocompleteMultiSelect,
  ComponentHeader,
  TextField,
} from "../../../../../components";

const FormSeventh = React.forwardRef(
  ({
    formikProps,
    editState,
    isDisabled,
    preferredChannels,
    forceClick,
    channelSectionRef,
  }) => {
    const { agent, role } = useSelector((state) => state.memberDetails);

    return (
      <Grid container spacing={4} ref={channelSectionRef}>
        <Grid size={12}>
          <ComponentHeader title={"Preferred Channel"} />
        </Grid>

        <Grid size={4}>
          <AutocompleteMultiSelect
            fullWidth
            required={true}
            forcePopupIcon={!editState ? false : true}
            label={"Select Preferred Channel"}
            name="pref_campaign_channel.value"
            formikProps={formikProps}
            disabled={
              !isDisabled &&
              (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                formikProps.values.status === "APPROVAL_REQUESTED")
                ? forceClick
                : !editState
            }
            placeholder="Select Preferred Channel"
            defaults={{
              primaryKey: "id",
              displayLabel: "channel_name",
            }}
            sx={{
              minWidth: "300px",
              "& .MuiSvgIcon-root": {
                display: !editState && "none",
              },
            }}
            options={
              agent?.length || role === "SUPER_ADMIN"
                ? preferredChannels
                : preferredChannels.filter((item) => item.id !== 1)
            }
            getOptionDisabled={(option) => !option.is_active}
            onChange={(_, arr, reason, option) =>
              handleChangeChannel(
                arr,
                reason,
                option,
                "pref_campaign_channel.value",
                "id"
              )
            }
          />
        </Grid>

        {(formikProps.values.pref_campaign_channel.value.includes(3) ||
          formikProps.values.pref_campaign_channel.value.includes(6)) && (
          <Grid size={12}>
            <Typography variant="body1" color="#808080">
              Note: you can provide these details at making campaign live.
            </Typography>
          </Grid>
        )}
        {formikProps.values.pref_campaign_channel?.value.includes(3) && (
          <Grid size={12}>
            <Typography variant="h6">Meta Delivery Details</Typography>
          </Grid>
        )}

        {/* {formikProps.values?.pref_campaign_channel?.value?.length !== 0 &&
        formikProps.values.pref_campaign_channel.value.includes(3) && (
          <Grid size={4}>
            <TextField
              required
              size="small"
              select
              disabled={!editState}
              name="meta_delivery_type.value"
              label="Delivery Type"
              formikProps={formikProps}
            >
              <MenuItem value="MANUAL">Manual</MenuItem>
              <MenuItem value="AUTOMATIC">Automatic</MenuItem>
            </TextField>
          </Grid>
        )} */}
        {formikProps.values.pref_campaign_channel?.value.includes(3) &&
          formikProps.values?.meta_delivery_type?.value === "MANUAL" && (
            <Grid size={4}>
              <TextField
                size="small"
                name="ad_manager_id.value"
                label="Ad Manager ID"
                placeholder="Ad Manager ID"
                formikProps={formikProps}
                disabled={
                  !isDisabled &&
                  (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                    formikProps.values.status === "APPROVAL_REQUESTED")
                    ? forceClick
                    : !editState
                }
              />
            </Grid>
          )}

        {formikProps.values.pref_campaign_channel?.value.includes(6) && (
          <Grid size={12}>
            <Typography variant="h6">DV360 Delivery Details</Typography>
          </Grid>
        )}

        {/* {formikProps.values?.pref_campaign_channel?.value?.length !== 0 &&
        formikProps.values.pref_campaign_channel.value.includes(6) && (
          <Grid size={4}>
            <TextField
              required
              size="small"
              select
              disabled={!editState}
              name="dv_delivery_type.value"
              label="Delivery Type"
              formikProps={formikProps}
            >
              <MenuItem value="MANUAL">Manual</MenuItem>
              <MenuItem value="AUTOMATIC">Automatic</MenuItem>
            </TextField>
          </Grid>
        )} */}
        {formikProps.values.pref_campaign_channel?.value.includes(6) &&
          formikProps.values?.dv_delivery_type?.value === "MANUAL" && (
            <Fragment>
              <Grid size={4}>
                <TextField
                  size="small"
                  name="dv_partner_id.value"
                  label="DV Partner ID"
                  placeholder="DV Partner ID"
                  formikProps={formikProps}
                  disabled={
                    !isDisabled &&
                    (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                      formikProps.values.status === "APPROVAL_REQUESTED")
                      ? forceClick
                      : !editState
                  }
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  size="small"
                  name="dv_advertiser_id.value"
                  label="DV Advertiser ID"
                  placeholder="DV Advertiser ID"
                  formikProps={formikProps}
                  disabled={
                    !isDisabled &&
                    (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                      formikProps.values.status === "APPROVAL_REQUESTED")
                      ? forceClick
                      : !editState
                  }
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  size="small"
                  name="dv_advertiser_name.value"
                  label="DV Advertiser Name"
                  placeholder="DV Advertiser Name"
                  formikProps={formikProps}
                  disabled={
                    !isDisabled &&
                    (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                      formikProps.values.status === "APPROVAL_REQUESTED")
                      ? forceClick
                      : !editState
                  }
                />
              </Grid>
            </Fragment>
          )}
      </Grid>
    );

    function handleChangeChannel(
      selectedOptions,
      reason,
      option,
      name,
      primaryKey
    ) {
      const objectName = name.substring(0, name.indexOf(".")); // e.g. "pref_campaign_channel"
      const values = selectedOptions.map((opt) => opt[primaryKey]);

      formikProps.setValues((prev) => {
        const updated = {
          ...prev,
          [objectName]: {
            ...prev[objectName],
            value: values,
          },
        };

        if (values.includes(3)) {
          updated.meta_delivery_type = { value: "MANUAL" };
        }

        if (values.includes(6)) {
          updated.dv_delivery_type = { value: "MANUAL" };
        }

        return updated;
      });
    }
  }
);

export default FormSeventh;
